
const SvgPaymentSuccessLottie = () => {
  return (
    <svg
      viewBox="0 0 11 11"
      width="120"
      height="120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none">
        <path
          d="m5.5 11a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"
          fill="#00c479"
        />
        <path
          d="m3.205 5.72a.66.66 0 0 0 -.91.956l1.475 1.406a.66.66 0 0 0 .894.016l4.43-3.938a.66.66 0 1 0 -.878-.987l-3.974 3.534z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default SvgPaymentSuccessLottie;
